module.exports = __webpack_public_path__ + "static/media/i6.9468a5d2.png";